"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _jusdaPublicmethod = require("@jusda-tools/jusda-publicmethod");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable no-alert */
var ipReg = /(?=(\b|\D))(((\d{1,2})|(1\d{1,2})|(2[0-4]\d)|(25[0-5]))\.){3}((\d{1,2})|(1\d{1,2})|(2[0-4]\d)|(25[0-5]))(?=(\b|\D))/;
var cookieAttributes = function cookieAttributes() {
  var _document = document,
    domain = _document.domain;
  var cookieDomain = ".".concat(domain.split('.').slice(-2).join('.'));
  if (document.domain.includes('localhost')) {
    alert('当前domain为 localhost 无法操作cookie! \n请使用域名或ip方式！');
  }
  // 192.169.124.11
  if (ipReg.test(domain)) {
    cookieDomain = domain;
  }
  return {
    path: '/',
    domain: cookieDomain,
    SameSite: 'None',
    Secure: true
  };
};
var CookieTools = exports["default"] = /*#__PURE__*/function () {
  function CookieTools() {
    (0, _classCallCheck2["default"])(this, CookieTools);
    this.options = cookieAttributes();
  }
  return (0, _createClass2["default"])(CookieTools, [{
    key: "get",
    value: function get(key) {
      return _jsCookie["default"].get(key);
    }
  }, {
    key: "set",
    value: function set(_ref) {
      var _this = this;
      var key = _ref.key,
        value = _ref.value,
        _ref$configuration = _ref.configuration,
        configuration = _ref$configuration === void 0 ? {} : _ref$configuration;
      _jsCookie["default"].set(key, value, _objectSpread(_objectSpread({}, this.options), configuration));
      return new Promise(function (resolve, reject) {
        var firstCookie = _jsCookie["default"].get(key);
        /*
        采用设置2次cookie的方式解决浏览器版本兼容问题
        1、如果浏览器版本为89(不含)以下版本cookie属性带SameSite、Secure会导致cookie写入不成功
        2、如果第一次设置不成功的话，就取消掉cookie中的SameSite、Secure属性，再次设置cookie
        ps:cookie加SameSite、Secure属性是为了iframe中的cookie能被正常使用(现在只有运输可视化和阿里合作的那个项目使用了)
        */
        if (value === firstCookie) {
          resolve(firstCookie);
        } else {
          var oldBrowsersOptions = _objectSpread({}, _this.options);
          // 删除cookie属性再次设置cookie
          delete oldBrowsersOptions.SameSite;
          delete oldBrowsersOptions.Secure;
          _jsCookie["default"].set(key, value, _objectSpread(_objectSpread({}, oldBrowsersOptions), configuration));
          var secondCookie = _jsCookie["default"].get(key);
          if (value === secondCookie) {
            resolve(secondCookie);
          } else {
            console.error('cookie设置失败');
            reject();
          }
        }
      });
    }
  }, {
    key: "remove",
    value: function remove(key) {
      _jsCookie["default"].remove(key, this.options);
    }
  }, {
    key: "removeToken",
    value: function removeToken() {
      this.remove(_jusdaPublicmethod.JUSDATOKEN);
    }
  }, {
    key: "getToken",
    value: function getToken() {
      return _jsCookie["default"].get(_jusdaPublicmethod.JUSDATOKEN);
    }
  }]);
}();